import { APP_TAB_PATHS, CREATOR_ROUTE } from '~/composables/useAppNavigation'

/** Account/settings pages: reachable from the header gear, not the tab bar. */
const SETTINGS_PATHS = [
  '/app/settings',
  '/app/settings/privacy',
  '/app/settings/terms',
  '/app/settings/blocked',
]

/** Post-signup onboarding flow (seeker photo / company logo prompts). */
const ONBOARDING_PATHS = [
  '/app/onboarding/interest',
  '/app/onboarding/profile',
  '/app/onboarding/photo',
  '/app/onboarding/company-details',
  '/app/onboarding/company-logo',
  '/app/onboarding/suggestions',
]

/**
 * Read-only profile viewers reached by tapping a name in cards:
 * /app/u/{profileId} (job seeker) and /app/c/{companyId} (company).
 * Creator nested tooling: /app/creator/stores/{id}/orders|configuration.
 * These are dynamic, so match by prefix rather than exact path.
 */
const DYNAMIC_APP_PREFIXES = [
  '/app/u/',
  '/app/c/',
  `${CREATOR_ROUTE}/`,
]

const VALID_APP_PATHS = new Set<string>([
  '/app',
  ...APP_TAB_PATHS,
  ...SETTINGS_PATHS,
  ...ONBOARDING_PATHS,
])

/** Legacy employer tab paths that should redirect instead of falling through to /app/cv. */
const LEGACY_APP_REDIRECTS: Record<string, string> = {
  '/app/company': '/app/publish',
  '/app/candidates': '/app/search-employee',
  '/app/offers': '/app/inbox/personal',
  '/app/applicants': '/app/inbox/business',
  '/app/jobs': '/app/cv',
}

export default defineNuxtRouteMiddleware((to) => {
  const legacyTarget = LEGACY_APP_REDIRECTS[to.path]
  if (legacyTarget && legacyTarget !== to.path) {
    return navigateTo(legacyTarget, { replace: true })
  }

  const isAppRoute = to.path === '/app' || to.path.startsWith('/app/')

  if (!isAppRoute) {
    return
  }

  if (DYNAMIC_APP_PREFIXES.some(prefix => to.path.startsWith(prefix))) {
    return
  }

  if (!VALID_APP_PATHS.has(to.path)) {
    return navigateTo('/app/home')
  }
})
